import './Hero.css'

function Hero() {
  return (
    <section className="hero">
      {/* Background Effects */}
      <div className="hero-bg">
        <div className="hero-gradient"></div>
        <div className="hero-grid"></div>
        <div className="hero-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>
      </div>

      <div className="container hero-container">
        {/* Badge */}
        <div className="hero-badge animate-fade-in-up">
          <span className="badge-dot"></span>
          <span>Introducing the unified business platform</span>
        </div>

        {/* Main Headline */}
        <h1 className="hero-title animate-fade-in-up animate-delay-100">
          <span className="hero-title-line">Run your entire</span>
          <span className="hero-title-line">
            <span className="gradient-text">business</span> from one place
          </span>
        </h1>

        {/* Subtitle */}
        <p className="hero-subtitle animate-fade-in-up animate-delay-200">
          Hubthrill brings websites, payments, accounting, support, HR, and hosting 
          into one platform. One login. One dashboard. One bill. Built for businesses 
          that refuse to compromise.
        </p>

        {/* CTAs */}
        <div className="hero-actions animate-fade-in-up animate-delay-300">
          <a href="/signup" className="btn btn-primary btn-lg">
            Start building for free
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <a href="/demo" className="btn btn-secondary btn-lg">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
            Watch demo
          </a>
        </div>

        {/* Social Proof */}
        <div className="hero-proof animate-fade-in-up animate-delay-400">
          <div className="proof-stats">
            <div className="proof-stat">
              <span className="stat-value">10K+</span>
              <span className="stat-label">Businesses</span>
            </div>
            <div className="proof-divider"></div>
            <div className="proof-stat">
              <span className="stat-value">$2B+</span>
              <span className="stat-label">Processed</span>
            </div>
            <div className="proof-divider"></div>
            <div className="proof-stat">
              <span className="stat-value">99.9%</span>
              <span className="stat-label">Uptime</span>
            </div>
          </div>
        </div>

        {/* Hero Visual */}
        <div className="hero-visual animate-fade-in-up animate-delay-500">
          <div className="visual-window">
            <div className="window-header">
              <div className="window-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div className="window-title">Hubthrill Dashboard</div>
            </div>
            <div className="window-content">
              <div className="dashboard-preview">
                <div className="preview-sidebar">
                  <div className="sidebar-item active">
                    <div className="item-icon payments"></div>
                    <span>Payments</span>
                  </div>
                  <div className="sidebar-item">
                    <div className="item-icon accounting"></div>
                    <span>Accounting</span>
                  </div>
                  <div className="sidebar-item">
                    <div className="item-icon infrastructure"></div>
                    <span>Infrastructure</span>
                  </div>
                </div>
                <div className="preview-main">
                  <div className="preview-cards">
                    <div className="preview-card">
                      <div className="card-label">Revenue</div>
                      <div className="card-value">$48,295</div>
                      <div className="card-trend positive">+12.5%</div>
                    </div>
                    <div className="preview-card">
                      <div className="card-label">Transactions</div>
                      <div className="card-value">1,429</div>
                      <div className="card-trend positive">+8.2%</div>
                    </div>
                    <div className="preview-card">
                      <div className="card-label">Active Users</div>
                      <div className="card-value">892</div>
                      <div className="card-trend positive">+24.1%</div>
                    </div>
                  </div>
                  <div className="preview-chart">
                    <svg viewBox="0 0 400 100" className="chart-line">
                      <defs>
                        <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" stopColor="rgba(124, 58, 237, 0.3)"/>
                          <stop offset="100%" stopColor="rgba(124, 58, 237, 0)"/>
                        </linearGradient>
                      </defs>
                      <path 
                        d="M0,80 Q50,70 100,60 T200,40 T300,50 T400,20" 
                        fill="none" 
                        stroke="url(#lineGradient)" 
                        strokeWidth="2"
                      />
                      <defs>
                        <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stopColor="#7C3AED"/>
                          <stop offset="100%" stopColor="#06B6D4"/>
                        </linearGradient>
                      </defs>
                      <path 
                        d="M0,80 Q50,70 100,60 T200,40 T300,50 T400,20 L400,100 L0,100 Z" 
                        fill="url(#chartGradient)"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Floating Cards */}
          <div className="floating-card card-left">
            <div className="floating-icon success">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <div className="floating-content">
              <span className="floating-title">Payment received</span>
              <span className="floating-value">+$1,250.00</span>
            </div>
          </div>
          
          <div className="floating-card card-right">
            <div className="floating-icon info">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="8" rx="2"/>
                <rect x="2" y="14" width="20" height="8" rx="2"/>
                <circle cx="6" cy="6" r="1" fill="currentColor"/>
                <circle cx="6" cy="18" r="1" fill="currentColor"/>
              </svg>
            </div>
            <div className="floating-content">
              <span className="floating-title">Deployment complete</span>
              <span className="floating-value">api.hubthrill.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
